"use client";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
const faqs = [{
  question: "How do I schedule a free inspection?",
  answer: "You can schedule your free inspection by calling us directly or filling out the form on our Contact page. We will visit your property to assess your specific pest concerns and provide a tailored treatment plan.",
  note: "see also: contact page, scheduling"
}, {
  question: "Are your treatments safe for pets and children?",
  answer: "Yes. We prioritize the safety of your family and pets. Our technicians use industry-leading, eco-conscious products and application methods that target pests while minimizing exposure to your living environment.",
  note: "available year-round, safety first"
}, {
  question: "What areas do you serve?",
  answer: "We proudly serve Punta Gorda, Port Charlotte, Cape Coral, Burnt Store, and North Fort Myers. Our local team is familiar with the specific pest challenges unique to Southwest Florida.",
  note: ""
}, {
  question: "How do I cancel or reschedule service?",
  answer: "We understand that plans change. You can cancel or reschedule your service by contacting us at least 24 hours in advance. We are happy to work with your schedule to ensure your home remains protected.",
  note: "we prefer a quick call to adjust your plan"
}, {
  question: "Do you offer emergency pest services?",
  answer: "We provide rapid response for urgent pest issues. If you have a sudden infestation or a critical pest problem, please call us immediately so we can prioritize your service request.",
  note: "see also: emergency contact"
}, {
  question: "Are you licensed?",
  answer: "Absolutely. All our technicians are fully insured and FDACS Licensed Pest Control and Termite Operators. We maintain rigorous training standards to ensure professional and effective service.",
  note: ""
}, {
  question: "Can I customize my pest control plan?",
  answer: "Yes. We offer flexible, customized plans based on your home's size and the specific pests you are dealing with. Whether you need one-time treatment or ongoing protection, we have a solution for you.",
  note: ""
}, {
  question: "What is included in a termite treatment?",
  answer: "Our termite treatments include a comprehensive inspection, identification of termite activity, and the application of advanced barrier or baiting systems to eliminate colonies and prevent future damage to your structure.",
  note: "first inspection within 48 hours of request"
}];
export default function () {
  return <section data-section-id="1912" id="pestcontrolfaq" className="relative bg-background text-foreground border-t border-border py-24 md:py-32 overflow-hidden">
      <div className="relative max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
        {}
        <div aria-hidden="true" className="pointer-events-none absolute right-0 top-1/2 -translate-y-1/2 select-none font-default italic text-foreground/5 leading-none" style={{
        fontSize: "22rem"
      }}>
          ?
        </div>

        <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              {}
              <div className="font-default text-xs font-medium uppercase tracking-[0.16em] text-foreground leading-none">
                § FREQUENTLY ASKED
              </div>

              {}
              <h2 className="mt-6 font-default text-foreground font-normal leading-[1.08] tracking-[-0.018em]" style={{
              fontSize: "clamp(2.125rem, 3.6vw, 3.25rem)"
            }}>
                Common <em className="italic">questions</em>, expert solutions.
              </h2>

              {}
              <div className="mt-8 flex items-center gap-0 max-w-sm">
                <div className="h-px flex-1 bg-border" />
                <div className="size-1.5 bg-primary" />
              </div>

              {}
              <p className="mt-8 font-serif italic text-secondary leading-[1.55]" style={{
              fontSize: "clamp(1.125rem, 1.4vw, 1.375rem)"
            }}>
                If your specific pest concern isn't addressed below, our local team is ready to assist you by phone or email.
              </p>

              {}
              <div className="mt-8 space-y-2">
                <div className="font-mono text-sm text-foreground tracking-[0.04em]">(941) 888-0485</div>
                <div className="font-mono text-sm text-foreground tracking-[0.04em]">steve@peaceriverpest.com</div>
              </div>

              {}
              <div className="mt-10 pl-4 border-l border-border">
                <p className="font-serif italic text-secondary text-[13px] leading-[1.5]">
                  or simply call us to speak with a local expert
                </p>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 relative">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="border-b-0 border-t border-border last:border-b last:border-b-border group">
                  <AccordionTrigger className="py-6 hover:no-underline [&>svg]:hidden gap-6 items-center">
                    <span className="font-default text-[17px] leading-[1.3] text-foreground font-normal text-left flex-1">
                      {faq.question}
                    </span>
                    <span aria-hidden="true" className="font-mono text-lg text-foreground leading-none shrink-0 w-4 text-center group-data-[state=open]:hidden">
                      +
                    </span>
                    <span aria-hidden="true" className="font-mono text-lg text-primary leading-none shrink-0 w-4 text-center hidden group-data-[state=open]:inline">
                      —
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="pt-0 pb-0">
                    <div className="pt-6 pb-8 pr-10">
                      <p className="font-serif text-secondary" style={{
                    fontSize: "15px",
                    lineHeight: 1.65
                  }}>
                        {faq.answer}
                      </p>
                      {faq.note && <p className="mt-5 font-serif italic text-[13px] leading-[1.5] text-secondary/85">
                          {i === 0 ? <>see also: <Link to="/ContactPage">contact page</Link>, scheduling</> : faq.note}
                        </p>}
                    </div>
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}